<template>
    <div>
        <button
            class="btn btn-md is-ghost px-2xl"
            title="Ändra status på leveransprojektet"
            @click="$modal.show('update-delivery-project-status')"
        >
            Ändra status
        </button>
        <adaptive-form-modal
            name="update-delivery-project-status"
            primary-button-text="Spara"
            primary-button-class="is-primary"
            title="Ändra status på leveransprojekt"
            method="patch"
            :action="route('api.delivery-project-statuses.update', deliveryProject)"
            :redirect-to="route('admin.delivery-projects.show', deliveryProject)"
        >
            <div>
                <select-input
                    name="status"
                    :value="deliveryProject.status"
                    :options="statuses"
                    :required="true"
                    :opt-out-sorting="true"
                >
                    Status
                </select-input>
            </div>
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            deliveryProject: {
                type: Object,
                required: true,
            },
            statuses: {
                type: Object,
                required: true,
            },
        },
    };
</script>
